import {
    MessageTooltip,
    pxToRem,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import React from 'react';

interface HoverActionProps {
    label: string;
    action: JSX.Element;
    position?: 'above' | 'below' | 'before' | 'after';
}

export const HoverAction = ({
    label,
    action,
    position = 'below',
}: HoverActionProps) => {
    const [tooltipEnabled, setTooltipEnabled] = React.useState(false);
    const { mobile: isMobile } = useAppDisplayModeContext();

    if (isMobile) {
        return action;
    }

    //todo remove conditional content render when ssr issue with northstar Tooltip has been resolved
    return (
        <MessageTooltip
            trigger={
                <span
                    onMouseEnter={() => setTooltipEnabled(true)}
                    onMouseLeave={() => setTooltipEnabled(false)}
                >
                    {action}
                </span>
            }
            content={
                tooltipEnabled
                    ? {
                          children: label,
                          size: 16,
                          padding: 16,
                          variables: { maxWidth: pxToRem(220) },
                      }
                    : null
            }
            position={position}
            offset={[-1, 12]}
        />
    );
};
